import { Stack } from "@chakra-ui/react";

import { RoutesMap } from "../../routes.tsx";
import { PageHeader } from "../../components/shared/PageHeader";
import { DocumentsPageContent } from "../../components/features/Profile/DocumentsPage";

export function DocumentsPage() {
  return (
    <Stack id="documentsPage" minH="100svh" px="4px" pb="20px" spacing={0}>
      <PageHeader title="Документы" link={RoutesMap.profile} />

      <DocumentsPageContent />
    </Stack>
  );
}
